import { render, staticRenderFns } from "./CarComp.vue?vue&type=template&id=107fead0&scoped=true"
import script from "./CarComp.vue?vue&type=script&setup=true&lang=js"
export * from "./CarComp.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CarComp.vue?vue&type=style&index=0&id=107fead0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107fead0",
  null
  
)

export default component.exports